import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { ConfigContext } from "../ConfigContextProvider";
import { LocaleContext } from "../LocaleContextProvider";
import { FormattedMessage, injectIntl } from "react-intl";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { useGooglePlaces } from "../../hooks/useGooglePlaces";

const FormConfigurator = (props) => {
  const { closeModal, appId, eleId, redirectUri } = props;
  const {
    REGISTER_URL,
    COUNTRY_URL,
    SECTOR_URL,
    ROLE_URL,
    PROFESSION_URL,
    CONFIGURATOR_URL,
  } = useContext(ConfigContext);

  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const { locale } = useContext(LocaleContext);

  //register
  const [mode, setMode] = useState("LOGIN");

  const [countries, setCountries] = useState();
  const [roles, setRoles] = useState();
  const [sectors, setSectors] = useState();
  const [userOptionsData, setUserOptionsData] = useState({}); // Nuovo stato per i dati userOptions

  const [status, setStatus] = useState();
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Nuovo stato per il loading
  const [statusChangePwd, setStatusChangePwd] = useState();
  const [professions, setProfessions] = useState();

  // Ref per l'input dell'indirizzo
  const addressInputRef = useRef(null);

  const translateText = function (tstr) {
    return props.intl.formatMessage({
      id: tstr,
    });
  };

  const verifyRecaptchaCallback = React.useCallback((token) => {
    setToken(token);
  }, []);

  const genericError = props.intl.formatMessage({
    id: "generic.form.error",
  });

  const { register, handleSubmit, watch, errors, setValue } = useForm({
    mode: "all",
    reValidateMode: "all",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  // Callback per quando viene selezionato un indirizzo da Google Places
  const handlePlaceSelected = useCallback((placeData) => {
    if (placeData.formattedAddress) {
      setValue('frm_indirizzo', placeData.formattedAddress);
    }
    
    // Aggiorna altri campi se disponibili
    if (placeData.addressComponents) {
      if (placeData.addressComponents.city) {
        setValue('frm_citta', placeData.addressComponents.city);
      }
    }
  }, [setValue]);

  // Hook per Google Places Autocomplete
  const { isLoaded } = useGooglePlaces(addressInputRef, handlePlaceSelected);

  const passwordWatch = useRef({});
  passwordWatch.current = watch("pwd", "");

  // Funzione userOption adattata per React
  const fetchUserOptions = async (
    customParams = { eleid: eleId, lang: locale, appid: "3cadconfigurator" }
  ) => {
    const baseUrl = "https://www.flou.it/bedconfigurator/model/useroptions.php";

    // Prendi i parametri esistenti dalla URL
    const urlParams = new URLSearchParams(window.location.search);

    // Aggiungi i parametri custom
    Object.keys(customParams).forEach((key) => {
      if (customParams[key] !== null && customParams[key] !== undefined) {
        urlParams.set(key, customParams[key]);
      }
    });

    // Costruisci l'URL finale
    const url = urlParams.toString()
      ? `${baseUrl}?${urlParams.toString()}`
      : baseUrl;

    let data = {};

    try {
      const response = await fetch(url);
      if (response.ok) {
        data = await response.json();
      }
    } catch (error) {
      console.error("Errore fetchUserOptions:", error);
    }

    return data;
  };

  const convertToEntities = function (tstr) {
    var bstr = "";
    for (let i = 0; i < tstr.length; i++) {
      if (tstr.charCodeAt(i) > 127) {
        bstr += "&#" + tstr.charCodeAt(i) + ";";
      } else {
        bstr += tstr.charAt(i);
      }
    }
    return bstr;
  };

  const onSignIn = useCallback(
    (data) => {
      setIsLoading(true);
      setStatus();
      setSuccessMessage();

      // Crea un form nascosto per il POST diretto
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = CONFIGURATOR_URL;
      form.target = '_blank';
      form.style.display = 'none';

      // Prepara i dati per la nuova API PHP
      const allData = {
        appId: appId,
        eleId: eleId,
        ...data,
        ...userOptionsData.settings,
        action: "submit",
        locale: locale,
        redirect_uri: redirectUri || window.location.href,
      };

      // Aggiungi tutti i campi come input nascosti
      Object.keys(allData).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        if (key === "usr") {
          input.value = convertToEntities(allData[key]);
        } else {
          input.value = allData[key] || '';
        }
        form.appendChild(input);
      });

      // Aggiungi il form al DOM e sottoponilo
      document.body.appendChild(form);
      setIsLoading(false);
      form.submit();
      document.body.removeChild(form);
      closeModal();
    },
    [userOptionsData, locale, appId, redirectUri, CONFIGURATOR_URL]
  );

  

  // Funzione helper per estrarre i settings dalla nuova response
  function extractSettingsFromResponse(responseJson) {
    // Adatta questa funzione in base alla struttura effettiva della response della tua API

    if (responseJson.data && responseJson.data.result) {
      // Se i settings sono in data.result
      return responseJson.data.result;
    }

    if (responseJson.data && responseJson.data.userOption) {
      // Se i settings sono in data.userOption
      return responseJson.data.userOption;
    }

    // Se i settings sono direttamente in data
    if (responseJson.data) {
      return responseJson.data;
    }

    // Fallback: restituisci un oggetto vuoto con valori di default
    return {
      login: "0",
      ssid: null,
      uidr: null,
      loginmsg: "Errore nella risposta del server",
    };
  }

  useEffect(() => {
    // Carica countries, roles, sectors come prima
    fetch(COUNTRY_URL)
      .then((res) => res.json())
      .then(
        (result) => {
          setCountries(result.countries);
        },
        (error) => {}
      );

    /*fetch(ROLE_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setRoles(result.ruoli);
        },
        (error) => {}
      );

    fetch(SECTOR_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setSectors(result.settori);
        },
        (error) => {}
      );*/

    fetch(PROFESSION_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setProfessions(result.professioni);
        },
        (error) => {}
      );

    // Carica userOptions e imposta i valori del form
    fetchUserOptions().then((data) => {
      if (Object.keys(data).length > 0) {
        setUserOptionsData(data);

        // Imposta i valori nel form per i campi esistenti
        /*Object.entries(data).forEach(([key, value]) => {
          // Solo per campi che esistono nel form
          if (['name', 'surname', 'email', 'phone', 'country', 'city', 'company', 'lang', 'appId'].includes(key)) {
            setValue(key, value);
          }
        });*/
      }
    });
  }, [setValue]);

  const appIdLabel = (appId && appId.length) > 0 ? appId + "." : "";

  return (
    <>
      {/* Loading Overlay */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      )}
      {status === "SUCCESS" ? (
        <>
          <div className="AuthenticationModal__title">
            <div className="AuthenticationModal__title">
              <h2>
                <FormattedMessage id={"register.form.title.success"} />
              </h2>
            </div>
          </div>
          <div className="AuthenticationModal__message">
            <p
              dangerouslySetInnerHTML={{
                __html: props.intl.formatMessage({
                  id: "register.form.success",
                }),
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="AuthenticationModal__title">
            <div className="AuthenticationModal__title">
              <h2>
                <FormattedMessage id={appIdLabel + "register.form.title"} />
              </h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.intl.formatMessage({
                    id: appIdLabel + "register.form.description",
                  }),
                }}
              />
              <p className="AuthenticationModal__mandatory">
                <FormattedMessage id={"form.mandatory.fields"} />
              </p>
            </div>
          </div>
          {errorMessage && <p className="textInput__error">{errorMessage}</p>}
          <form onSubmit={handleSubmit(onSignIn)}>
            <input
              type="hidden"
              name="g-recaptcha-response"
              value={token}
              ref={register({ required: true })}
            />
            <input
              type="hidden"
              name="lang"
              defaultValue={locale}
              ref={register({ required: true })}
            />
            <input
              type="hidden"
              name="appId"
              defaultValue={appId}
              ref={register()}
            />

            <div className="AuthenticationModal__rowForm">
              {/* nome */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-name" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.name" })}*
                </label>
                <input
                  id="configurator-name"
                  className="textInput__input"
                  name="frm_nome"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.name",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.name" })}*`}
                  aria-describedby={errors.frm_nome ? "configurator-name-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.frm_nome && errors.frm_nome.message && (
                  <p id="configurator-name-error" className="textInput__error">{errors.frm_nome.message}</p>
                )}
              </div>

              {/* cognome */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-surname" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.surname" })}*
                </label>
                <input
                  id="configurator-surname"
                  className="textInput__input"
                  name="frm_cognome"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.surname",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.surname" })}*`}
                  aria-describedby={errors.frm_cognome ? "configurator-surname-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.frm_cognome && errors.frm_cognome.message && (
                  <p id="configurator-surname-error" className="textInput__error">{errors.frm_cognome.message}</p>
                )}
              </div>
            </div>
            <div className="AuthenticationModal__rowForm">
              {/* email */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-email" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.email" })}*
                </label>
                <input
                  id="configurator-email"
                  className="textInput__input"
                  name="frm_email"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.email",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.email" })}*`}
                  aria-describedby={errors.frm_email ? "configurator-email-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: props.intl.formatMessage({
                        id: "validation.email",
                      }),
                    },
                  })}
                />
                {errors.frm_email && errors.frm_email.message && (
                  <p id="configurator-email-error" className="textInput__error">{errors.frm_email.message}</p>
                )}
              </div>

              {/* phone */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-phone" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.phone" })}*
                </label>
                <input
                  id="configurator-phone"
                  className="textInput__input"
                  name="frm_telefono"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.phone",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.phone" })}*`}
                  aria-describedby={errors.frm_telefono ? "configurator-phone-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.frm_telefono && errors.frm_telefono.message && (
                  <p id="configurator-phone-error" className="textInput__error">{errors.frm_telefono.message}</p>
                )}
              </div>
            </div>
            <div className="AuthenticationModal__rowForm">
              {/* country */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-country" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.select.country" })}*
                </label>
                <select
                  id="configurator-country"
                  name="frm_nazione"
                  defaultValue=""
                  className="textInput__input"
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.select.country" })}*`}
                  aria-describedby={errors.frm_nazione ? "configurator-country-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                    pattern: {
                      value: /^[a-zA-Z]{2,}$/,
                      message: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                    },
                  })}
                >
                  <option key={"option"} value={""} disabled>
                    {`${props.intl.formatMessage({
                      id: "placeholder.select.country",
                    })}*`}
                  </option>
                  {countries &&
                    countries.map((item, i) => {
                      return (
                        <option key={"option" + i} value={item.id}>
                          {item.label}
                        </option>
                      );
                    })}
                </select>
                {errors.frm_nazione && errors.frm_nazione.message && (
                  <p id="configurator-country-error" className="textInput__error">{errors.frm_nazione.message}</p>
                )}
              </div>

              {/* city */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-city" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.city" })}*
                </label>
                <input
                  id="configurator-city"
                  className="textInput__input"
                  name="frm_citta"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.city",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.city" })}*`}
                  aria-describedby={errors.frm_citta ? "configurator-city-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.frm_citta && errors.frm_citta.message && (
                  <p id="configurator-city-error" className="textInput__error">{errors.frm_citta.message}</p>
                )}
              </div>
            </div>

            <div className="AuthenticationModal__rowForm">
              {/* address */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-address" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.address" })}*
                </label>
                <input
                  id="configurator-address"
                  className="textInput__input"
                  name="frm_indirizzo"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.address",
                  })}*`}
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.address" })}*`}
                  aria-describedby={errors.frm_indirizzo ? "configurator-address-error" : undefined}
                  ref={(e) => {
                    register({
                      required: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                    })(e);
                    addressInputRef.current = e;
                  }}
                  autoComplete="off"
                />
                {errors.frm_indirizzo && errors.frm_indirizzo.message && (
                  <p id="configurator-address-error" className="textInput__error">{errors.frm_indirizzo.message}</p>
                )}
              </div>

              {/* profession */}
              <div className="textInput__wrapper">
                <label htmlFor="configurator-profession" className="sr-only">
                  {props.intl.formatMessage({ id: "placeholder.select.professions" })}*
                </label>
                <select
                  id="configurator-profession"
                  name="frm_professione"
                  defaultValue=""
                  className="textInput__input"
                  aria-label={`${props.intl.formatMessage({ id: "placeholder.select.professions" })}*`}
                  aria-describedby={errors.frm_professione ? "configurator-profession-error" : undefined}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                    pattern: {
                      value: /.+/,
                      message: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                    },
                  })}
                >
                  <option key={"option"} value={""} disabled>
                    {`${props.intl.formatMessage({
                      id: "placeholder.select.professions",
                    })}*`}
                  </option>
                  {professions &&
                    professions.map((item, i) => {
                      return (
                        <option key={"option" + i} value={item.id}>
                          {item.label}
                        </option>
                      );
                    })}
                </select>
                {errors.frm_professione && errors.frm_professione.message && (
                  <p id="configurator-profession-error" className="textInput__error">
                    {errors.frm_professione.message}
                  </p>
                )}
              </div>
            </div>

            <p className="AuthenticationModal__policy">
              <span
                dangerouslySetInnerHTML={{
                  __html: props.intl.formatMessage({
                    id: "bedconfigurator.register.policy.description",
                  }),
                }}
              />
            </p>

            <p></p>

            <div className="textInput__wrapper textInput__wrapper--policy">
              <div className="textInput__policyBlock">
                <input
                  type="checkbox"
                  className="textInput__checkboxPolicy"
                  name="policy_b"
                  id="policy_b"
                  ref={register({})}
                />
                <div>
                  <label
                    htmlFor="policy_b"
                    className="textInput__policy"
                    dangerouslySetInnerHTML={{
                      __html: props.intl.formatMessage({
                        id: "bedconfigurator.form.policy_b",
                      }),
                    }}
                  ></label>
                </div>
              </div>
            </div>

            <div className="textInput__wrapper textInput__wrapper--policy">
              <div className="textInput__policyBlock">
                <input
                  type="checkbox"
                  className="textInput__checkboxPolicy"
                  name="policy_c"
                  id="policy_c"
                  ref={register({})}
                />
                <div>
                  <label
                    htmlFor="policy_c"
                    className="textInput__policy"
                    dangerouslySetInnerHTML={{
                      __html: props.intl.formatMessage({
                        id: "bedconfigurator.form.policy_c",
                      }),
                    }}
                  ></label>
                </div>
              </div>
            </div>

            <GoogleReCaptcha onVerify={verifyRecaptchaCallback} />

            <button type="submit" className="AuthenticationModal__button">
              <FormattedMessage id={"bedconfigurator.register.form.button"} />
            </button>
          </form>

        
        </>
      )}
    </>
  );
};

export default injectIntl(FormConfigurator);
